import { all } from 'redux-saga/effects';
import errorHandlerSaga from './errorHandler/saga';
import authSaga from './auth/saga';

export default function* rootSaga() {
  yield all([authSaga(), errorHandlerSaga()]);
}
